import React, { useEffect, useState } from 'react';
import "../Styles/CreateUser.css";
import * as yup from "yup";
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { ErrorMessage, Formik, Form, Field } from "formik";
import Axios from "axios";
import { toast, ToastContainer, toast as toastHelper } from 'react-toastify';
import MDUserProfileHeader from './MDUserProfileHeader';
import Img from "../Assets/icons/VELOXLogo.png";

const MDCreateT = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { mdId } = useParams();
  const siId = localStorage.getItem("siId");

  const hasSi = siId !== null && siId !== undefined && String(siId).trim() !== "";

  const ROLE_NAME_TO_ID = hasSi ? { Admin: 1, Technician: 2 } : { Admin: 3, Technician: 4 };

  const handleBack = () => {
    toastHelper.dismiss();
    if (window.history.state && window.history.state.idx > 0) {
      navigate(-1);
      console.log("Navigating back one step.");
    } else {
      navigate('/dashboard', { replace: true });
      console.log("No history to go back, redirecting to dashboard.");
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('@user');
    localStorage.removeItem('userEmail');
    toastHelper.dismiss();
    navigate('/', { replace: true });
  };

  const handleCreateUser = (values, { resetForm }) => {
    Axios.post(`/create_company_user`, {
      mdId: mdId,
      siId: hasSi ? String(siId).trim() : null,
      firstname: values.firstname,
      lastname: values.lastname,
      email: values.email,
      yubikey: values.yubikeyserialnumber,
      adminEmail: localStorage.getItem('userEmail'),
      role: ROLE_NAME_TO_ID[values.role] ?? ROLE_NAME_TO_ID.Technician,
    }).then((response) => {
      if (response && response.data && response.data.success) {
        toast.success(response.data.msg || "User created successfully!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        resetForm();
      } else {
        toast.error(response.data.msg || "Failed to add user, please try again!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      }
    }).catch(() => {
      toast.error("Failed to add user, please try again!", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    });
  };

  const validationsCreateUser = yup.object().shape({
    firstname: yup.string().required("First name is mandatory"),
    lastname: yup.string().required("Last name is mandatory"),
    email: yup.string().email("Invalid email").required("Email is mandatory"),
  });

  return (
    <div className="dashboard">
      <MDUserProfileHeader isAdmin={true} />
      <div className="all-users-card">
        <h1 className="Title-alluser">Create User In Your Company</h1>
        <Formik
          initialValues={{
            firstname: '',
            lastname: '',
            email: '',
            password: '',
            yubikeyserialnumber: '',
            role: 'Technician',
          }}
          onSubmit={handleCreateUser}
          validationSchema={validationsCreateUser}
        >
          <Form className="register-form">
            <div className="register-form-group">
              <Field name="firstname" type='text' className="register-form-firstname-field" placeholder="First name" />
              <ErrorMessage component="span" name="firstname" className="adduser-form-error" />
            </div>

            <div className="register-form-group">
              <Field name="lastname" type='text' className="register-form-lastname-field" placeholder="Last name" />
              <ErrorMessage component="span" name="lastname" className="adduser-form-error" />
            </div>

            <div className="register-form-group">
              <Field name="email" type='text' className="register-form-email-field" placeholder="Email" />
              <ErrorMessage component="span" name="email" className="adduser-form-error" />
            </div>

            <div className="register-form-group">
              <Field as="select" name="role" className="register-form-lastname-field">
                <option value="Technician">Technician</option>
                <option value="Admin">Admin</option>
              </Field>
            </div>

            <div className="register-form-group">
              <Field name="yubikeyserialnumber" type='text' className="register-form-yubikeyserialnumber-field" placeholder="VELOX Cloud Key Serial Number" />
            </div>

            <button className="createuser-button" type="submit">
              Create User
            </button>
          </Form>
        </Formik>
      </div>
    </div>
  );
};

export default MDCreateT;